<template>
    <header class="channel-page-header" :style="headerStyle">
        <BrandTileCmp class="cph-tile" :size="56" :image="markUrl" :icon="isCustom ? 'store-alt' : null"
            :text="brand.monogram" :background="brand.color" :color="brand.textColor" />

        <div class="cph-text">
            <p class="cph-eyebrow">{{eyebrow}}</p>
            <h1 class="cph-title">{{realName}}</h1>
            <p class="cph-alias" v-if="alias">{{alias}}</p>
        </div>

        <div class="cph-actions" v-if="$slots.default">
            <slot />
        </div>
    </header>
</template>

<script>
import { getChannelBrand, getChannelGlow } from '@/channel/models/ChannelBrand'
import { ChannelEnum } from '@c2b/muven-commons'
import BrandTileCmp from '@/utils/components/BrandTileCmp.vue'

/**
 * Cabeçalho compacto das subtelas do canal: a marca aparece aqui, uma vez, como
 * identidade. O resto da tela fica neutro.
 */
export default {
    name: 'ChannelPageHeaderCmp',
    components: {
        BrandTileCmp,
    },
    props: {
        channel: {
            type: Object,
            required: true,
        },
        // Nome da subtela (ex.: "Configurações gerais")
        eyebrow: {
            type: String,
            required: true,
        },
    },
    computed: {
        brand() {
            return getChannelBrand(this.channel.enumChannel)
        },
        isCustom() {
            return this.channel.enumChannel === ChannelEnum.Custom
        },
        realName() {
            return this.channel.getRealName ? this.channel.getRealName() : this.channel.name
        },
        alias() {
            return this.channel.hasCustomizedName && this.channel.hasCustomizedName() ? this.channel.name : ''
        },
        markUrl() {
            return this.brand.mark ? require(`@/channel/images/marks/${this.brand.mark}`) : null
        },
        headerStyle() {
            return {
                '--hero-glow': getChannelGlow(this.brand) || 'var(--brand)',
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.channel-page-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px 20px;
    padding: 20px 24px;
    border: 1px solid var(--border-subtle);
    border-radius: 18px;
    background:
        radial-gradient(ellipse 40% 140% at 0% 50%, color-mix(in srgb, var(--hero-glow) 10%, transparent), transparent 70%),
        var(--surface-1);
}

.cph-tile {
    box-shadow: var(--shadow-sm), 0 10px 22px -10px color-mix(in srgb, var(--hero-glow) 40%, transparent);
}

.cph-text {
    flex: 1 1 220px;
    min-width: 0;
}

.cph-eyebrow {
    margin: 0 0 2px;
    color: var(--text-faint);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .12em;
    text-transform: uppercase;
}

.cph-title {
    margin: 0;
    color: var(--text-strong);
    font-family: 'Bricolage Grotesque', 'Source Sans Pro', system-ui, sans-serif;
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -.6px;
    line-height: 1.1;
}

.cph-alias {
    margin: 4px 0 0;
    color: var(--text-muted);
    font-size: 14px;
    font-weight: 600;
}

.cph-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}
</style>
